import ArticleSlider from '@/views/article_slider';

$(document).on('turbolinks:load', () => {
  const node = document.querySelector('article.mobile_app_slider');
  if (!node) { return; }

  new ArticleSlider(node);
});
